import { put, select } from 'redux-saga/effects'
import { sagaActions } from '../sagas'
import {
  addLayout as addLayoutToView,
  removeLayout as removeLayoutFromView
} from '../redux/view'
import {
  add as addLayout,
  remove as removeLayout,
  setPosition as setLayoutPosition,
  setIsPublic as setLayoutIsPublic,
  setIsLocked as setLayoutIsLocked,
} from '../redux/layouts'
import {
  set as setPermissionLevelForLayout
} from '../redux/layoutPermissions'
import {
  removeBoardFromAll as removeBoardFromAllLayoutGroups
} from '../redux/layoutGroups'
import {
  set as setBoardUnreadActivitiesCount
} from '../redux/unreadBoardActivitiesCount'
import {
  remove as removeBoard,
  setName as setBoardName,
  setBackground as setBoardBackground,
  setIsPublic as setBoardIsPublic,
  setIsLocked as setBoardIsClosed,
} from 'store/redux/boards'
import { PermissionLevels } from 'utils/permission'

export default function * channelData (action) {
  const { channel, actionName, elementName, data } = action.payload

  const state = yield select()

  const currentUserId = state.kanbo.currentUser.id

  if (channel === 'users') { // Users channel
    if (actionName + elementName === 'AddUser/Data/User') {
      yield put(sagaActions.fetchUsers({ refresh: true }))
    }
  } else if (channel === 'landingPage') {
    if (actionName + elementName === 'RenameBoard/Data/Board') {
      const { Id, Name } = data
      yield put(setBoardName({
        id: Id,
        name: Name
      }))
    } else if (actionName + elementName === 'ChangeBoardBackground/Data/Board/Background') {
      const { Id, Background } = data

      yield put(setBoardBackground({
        id: Id,
        background: Background
      }))
    } else if (actionName + elementName === 'RemoveBoard/Primitive/Int32') {
      const { Value } = data

      yield put([
        removeBoardFromAllLayoutGroups({
          boardId: Value
        }),
        removeBoard({
          id: Value
        })
      ])
    } else if (actionName + elementName === 'OpenBoard/Data/Board/Id') {
      const { Id } = data

      yield put(setBoardIsClosed({
        id: Id,
        isClosed: false
      }))
    } else if (actionName + elementName === 'CloseBoard/Data/Board/Id') {
      const { Id } = data

      yield put(setBoardIsClosed({
        id: Id,
        isClosed: true
      }))
    } else if (actionName + elementName === 'RemoveHomeLayout/Primitive/MaybeInt32') {
      const { Value } = data

      yield put([
        removeLayout({
          id: Value
        }),
        removeLayoutFromView({
          id: Value
        })
      ])

      if (state['view-home'].view.layouts.includes(Value)) {
        yield put(sagaActions.fetchMyHomeLayouts())
      }
    } else if (actionName + elementName === 'SetHomeLayoutAsPublic/Primitive/Int32') {
      const { Value } = data

      yield put(setLayoutIsPublic({
        id: Value,
        isPublic: true
      }))
    } else if (actionName + elementName === 'SetHomeLayoutAsPrivate/Primitive/Int32') {
      const { Value } = data

      yield put(setLayoutIsPublic({
        id: Value,
        isPublic: false
      }))

      if (state['view-home'].view.layouts.includes(Value)) {
        yield put(sagaActions.fetchMyHomeLayouts())
      }
    } else if (actionName + elementName === 'HomeLayoutChanged/Data/HomeLayoutChanged') {
      const { Id } = data

      if (state['view-home'].view.layouts.includes(Id)) {
        yield put(sagaActions.fetchMyHomeLayouts())
      }
    } else if (actionName + elementName === 'SetBoardAsPrivate/Primitive/Int32') {
      const { Value } = data

      yield put(setBoardIsPublic({
        id: Value,
        isPublic: false
      }))
    } else if (actionName + elementName === 'SetBoardAsPublic/Primitive/Int32') {
      const { Value } = data

      yield put(setBoardIsPublic({
        id: Value,
        isPublic: true
      }))
    }
  } else if (channel.indexOf('homeLayout-') === 0) {
    if (actionName + elementName === 'AddUserToHomeLayout/Data/MyHomeLayoutUser') {
      const { HomeLayoutId, UserId, PermissionLevel } = data

      if (UserId === currentUserId) {
        yield put(setPermissionLevelForLayout({
          id: HomeLayoutId,
          permissionLevel: PermissionLevel
        }))
      }
    } else if (actionName + elementName === 'RemoveUserFromHomeLayout/Data/HomeLayoutUser') {
      const { HomeLayoutId, UserId } = data

      if (UserId === currentUserId) {
        yield put(setPermissionLevelForLayout({
          id: HomeLayoutId,
          permissionLevel: PermissionLevels.NONE
        }))
      }
    }
  } else if (channel === '@' + currentUserId) {
    if (actionName + elementName === 'Heartbeat/Data/Heartbeats') {
      const { Heartbeats } = data

      yield put(
        Heartbeats
          .filter(Heartbeat => Heartbeat.Location.indexOf('board-') === 0)
          .map(Heartbeat => setBoardUnreadActivitiesCount({
            id: +Heartbeat.Location.split('board-')[1],
            count: 0,
          }))
      )
    } else if (
      actionName + elementName === 'AddHomeLayout/Data/HomeLayout' ||
      actionName + elementName === 'AddMyHomeLayout/Data/MyHomeLayout' ||
      actionName + elementName === 'AddMyHomeLayout/Data/HomeLayout'
    ) {
      const Layout = data

      yield put(addLayout({
        id: Layout.Id,
        name: Layout.Name,
        description: Layout.Description,
        isPublic: Layout.IsPublic,
        isShared: Layout.IsShared,
        isTemplate: Layout.IsTemplate,
        isLocked: Layout.IsLocked,
        position: Layout.Position
      }))

      if (Layout.Position !== null) {
        yield put(addLayoutToView({
          id: Layout.Id
        }))
      }
    } else if (actionName + elementName === 'UnlockHomeLayout/Primitive/Int32') {
      const { Value } = data

      yield put(setLayoutIsLocked({
        id: Value,
        isLocked: false,
      }))
    } else if (actionName + elementName === 'RemoveMyHomeLayout/Primitive/MaybeInt32') {
      const { Value } = data

      yield put(removeLayoutFromView({
        id: Value
      }))
    } else if (actionName + elementName === 'MyHomeLayoutPositionChange/Data/HomeLayoutPositions') {
      const { Positions } = data

      yield put(Positions.map(({ Id, Position }) => setLayoutPosition({
        id: Id,
        position: Position
      })))
    } else if (actionName + elementName === 'RemoveUserFromHomeLayout/Data/HomeLayoutUser') {
      yield put(sagaActions.fetchMyHomeLayouts())
    } else if (actionName + elementName === 'HomeLayoutsPermissionChange/Data/Array<Int32>') {
      if (state['view-home'].view.layouts.some(layoutId => data.includes(layoutId))) {
        yield put(sagaActions.fetchMyHomeLayouts())
      }
    }
  }
}
